( function( $ ) {

    $(window).scroll(function(){
        if( $(this).scrollTop() > 90 ){
            $('#main-nav').addClass('bg-navbar');

        } else {
            if ( $('#main-nav').hasClass('bg-navbar')){
                $('#main-nav').removeClass('bg-navbar');
            }
        }
    });


    // validate form encuentra

    $(document).ready(function () {
        var resultform = 0;

        function recaptchaCallback() {
            $('#hiddenRecaptcha').valid();
        }

        if ($('#encuentraf').length) {
            $.validator.addMethod('customphone', function (value, element) {
                return this.optional(element) || /^[679]{1}[0-9]{8}$/.test(value);
            }, "Por favor entre un número de teléfono válido");
            $.validator.addMethod("minDate", function (value, element) {
                var curDate = new Date();
                // var dateParts = value.split("/");
                var dateParts = value.split("-");
                var age = 14;
                // var dateObject = new Date(parseInt(dateParts[2]) + age, dateParts[1] - 1, +dateParts[0]);
                // var inputDate = new Date(dateObject);
                var inputDate = new Date(value);
                inputDate.setFullYear( inputDate.getFullYear() + age);

                // var inputDate2 = new Date(
                //     parseInt(dateParts[0], 10),
                //     ( parseInt(dateParts[1], 10) - 1 ),
                //     parseInt(dateParts[2], 10)
                // );
                if (inputDate < curDate) return true;
                return false;
            }, "Debes ser mayor de 14 años");
            $('#encuentraf').validate({
                ignore: ".ignore",
                rules: {
                    inputnombre: {
                        required: true,
                        minlength: 3
                    },
                    inputapellidos: {
                        required: true,
                        minlength: 3
                    },
                    inputemail: {
                        required: true
                    },
                    inputtel: {
                        required: true,
                        customphone: true
                    },
                    inputfndate: {
                        required: true,
                        minDate: true
                    },
                    inputgenero: {
                        required: true
                    },
                    inputlegal: {
                        required: true
                    },
                    hiddenRecaptcha: {
                        required: function () {
                            if (grecaptcha.getResponse() == '') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                },
                messages: {
                    inputnombre: {
                        required: "Debe indicar su nombre",
                        minlength: jQuery.validator.format("Al menos {0} caracteres")
                    },
                    inputapellidos: {
                        required: "Debe indicar sus apellidos",
                        minlength: jQuery.validator.format("Al menos {0} caracteres")
                    },
                    inputemail: {
                        required: "Debe indicar su email",
                        email: "El email debe tener formato name@domain.com"
                    },
                    inputtel: {
                        required: "Debe indicar su teléfono"
                    },
                    inputfndate: {
                        required: "Debe indicar fecha de nacimiento"
                    },
                    inputgenero: {
                        required: "Debe indicar género"
                    },
                    inputlegal: {
                        required: "Debe aceptar las condicones y avisos legales"
                    },
                    hiddenRecaptcha: {
                        required: "Debe demostrar que no es un robot"
                    }
                },
                errorElement: "em",
                errorPlacement: function (error, element) {
                    // Add the `invalid-feedback` class to the error element
                    error.addClass("invalid-feedback");

                    if (element.prop("type") === "checkbox") {
                        error.insertAfter(element.next("label"));
                    } else {
                        if (element.hasClass('datetimepicker-input')) {
                            error.insertAfter(element.closest('.input-group'));
                        } else {
                            error.insertAfter(element);
                        }
                    }
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass("is-invalid").removeClass("is-valid");
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).addClass("is-valid").removeClass("is-invalid");
                },
                submitHandler: function (form) {
                    if (resultform == 0) {

                        try {
                            console.log("gtag");
                            gtag('event', 'contact', {'event_category': 'formulario-paciente','event_action': 'submit', 'event_label': 'formulario'});
                        } catch (error) {
                            console.error(error);
                        }


                        var datefnParts = $('#inputfndate').val( ).split("-");
                        $('#inputfn').val( datefnParts[2] + '/' + datefnParts[1] + '/' + datefnParts[0]);

                        $('.form-overlay').addClass('show');
                        var jqxhr = $.post("https://app.psicolink.es/web/", $("#encuentraf").serialize(), function (data) {
                            //var jqxhr = $.post("http://localhost:8888/psicolink/repositorios/psicolink/", $("#encuentraf").serialize(), function (data) {
                            data = JSON.parse(data);
                            resultform = parseInt(data.result);

                            if (resultform != 0) {
                                $('.form-show').slideToggle(800);
                            }

                            $('.form-overlay').removeClass('show');
                            $('.responseform').html(data.msg);
                            $('.responseform').fadeIn();
                            $('html,body').animate({
                                scrollTop: $('.responseform').offset().top - 50
                            }, 300);
                        }) //.done(function() {
                            //    alert( "second success" );
                            //})
                            .fail(function () {
                                $('.form-overlay').removeClass('show');
                                alert("Ha habido un error en el envío del formulario. Inténtelo de nuevo más tarde.");
                            });
                        alert('send!!');
                    } else {
                        alert("No se puede volver a enviar el formulario");
                    }
                }
            });
        }

    });



} )( jQuery );
